import { Scopes } from "helpers/auth";

/**
 * Determines if a user is a shop-only user based on their scopes.
 * A shop-only user has access to the shop page but not the home page.
 *
 * @param scopes - The user's scopes array
 * @param isSignedIn - Whether the user is currently signed in
 * @returns boolean - True if user is shop-only, false otherwise
 */
export const isShopOnlyUser = (scopes: Scopes, isSignedIn: boolean): boolean => {
  if (!isSignedIn || scopes.length === 0) {
    return false;
  }

  const hasShopAccess = scopes.some((scope) => scope.path === "shop");
  const hasHomeAccess = scopes.some((scope) => scope.path === "home");

  return hasShopAccess && !hasHomeAccess;
};
